import { getCurrentInstance as _getCurrentInstance } from 'vue';

import { paramCase } from './';

import type { ComponentInternalInstance } from 'vue';

/**
 * This is a wrapper around Vue's getCurrentInstance
 * WARNING! It's not a public API and can be removed in the future
 * @param name
 * @param message
 */
export function getCurrentInstance(name: string, message?: string) {
  const vm = _getCurrentInstance();

  if (!vm) {
    throw new Error(`[CDS] ${name} ${message || 'must be called from inside a setup function'}`);
  }

  return vm;
}

export function getCurrentInstanceName(name = 'composable') {
  const vm = getCurrentInstance(name);
  return paramCase(vm.type?.name || '');
}

let _uid = 0;
let _map = new WeakMap<ComponentInternalInstance, number>();
export function getUid() {
  const vm = getCurrentInstance('getUid');

  if (_map.has(vm)) {
    return _map.get(vm)!;
  } else {
    const uid = _uid++;
    _map.set(vm, uid);
    return uid;
  }
}
getUid.reset = () => {
  _uid = 0;
  _map = new WeakMap();
};
